// extracted by mini-css-extract-plugin
export default {"DateWrapper":"ModalChangeBranch_DateWrapper__l8oar","ErrorMessage":"ModalChangeBranch_ErrorMessage__l+L-A","FormLabel":"ModalChangeBranch_FormLabel__UDt7g"};